import type { MadeiraMobileMechanicContent } from './content.schema';

export const defaultContent: MadeiraMobileMechanicContent = {
  branding: {
    logoHref: '#home',
  },
  nav: {
    items: [
      { label: 'Services', href: '#services' },
      { label: 'About', href: '#about' },
      { label: 'Areas', href: '#areas' },
      { label: 'Reviews', href: '#reviews' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Location', href: '#location' },
      { label: 'Contact', href: '#contact' },
    ],
  },
  hero: {
    businessName: 'Madeira Mobile Mechanic',
    tagline: 'We Come To You, Anywhere on the Island',
    taglinePt: 'Vamos Até Si, Em Qualquer Ponto da Ilha',
    subtitle:
      'Mobile mechanic across the entire island of Madeira. Engine diagnostics, oil changes, brake service, battery replacement and more — at your location.',
    subtitlePt:
      'Mecânico ao domicílio em toda a Ilha da Madeira. Funchal, Caniço, Santa Cruz, Câmara de Lobos e muito mais. Diagnóstico de motor, mudança de óleo, travões, bateria — onde estiver.',
    phone: '+351 912 837 918',
    whatsapp: '+351 912 837 918',
    ownerTitle: 'Owner & Lead Mechanic',
    ownerSubtitle: 'English · Português',
  },
  buttons: {
    callLabel: 'Call Now',
    whatsappLabel: 'WhatsApp',
    emergencyLabel: '24h Emergency',
    bookLabel: 'Book a Visit',
  },
  stats: {
    rating: 'Transparent Quotes',
    reviewCount: '100+',
    experience: 'Island-Wide Service',
    carsServiced: 'Flexible Scheduling',
    responseTime: 'Insured Work',
  },
  services: {
    items: [
      {
        name: 'Engine Diagnostics',
        description:
          'Advanced OBD-II diagnostics to identify and resolve issues before they become costly problems.',
      },
      {
        name: 'Oil & Fluid Service',
        description:
          'Complete oil changes and fluid top-ups using premium-grade lubricants suited to your vehicle.',
      },
      {
        name: 'Brake Service',
        description:
          "Inspection, pad replacement, and brake fluid flush to keep you safe on Madeira's winding roads.",
      },
      {
        name: 'Battery Replacement',
        description:
          "Fast on-site battery testing and replacement so you're never left stranded.",
      },
      {
        name: 'Air Conditioning',
        description:
          "A/C recharge, leak detection and repair to keep your cabin cool in Madeira's climate.",
      },
      {
        name: 'Pre-Purchase Inspection',
        description:
          "Comprehensive vehicle inspection before you buy. Know exactly what you're getting into.",
      },
    ],
  },
  areas: {
    intro:
      'We cover the entire island of Madeira. Operamos em toda a Ilha da Madeira.',
    items: [
      { name: 'Funchal' },
      { name: 'Caniço' },
      { name: 'Câmara de Lobos' },
      { name: 'Calheta' },
      { name: 'Machico' },
      { name: 'Porto Moniz' },
      { name: 'Ponta do Sol' },
      { name: 'Porto Santo' },
      { name: 'Ribeira Brava' },
      { name: 'Santa Cruz' },
      { name: 'Santana' },
      { name: 'São Vicente' },
    ],
  },
  reviews: {
    items: [
      {
        author: 'João Ferreira',
        body: 'Absolutely exceptional service. My car broke down near Câmara de Lobos and they were with me within the hour. Fixed the issue on the spot. Fair price, genuine expertise.',
        rating: '5',
      },
      {
        author: 'Maria Rodrigues',
        body: 'Profissional, rápido e completamente honesto. Fez a revisão completa no meu local de trabalho, sem perda de tempo nem custos de reboque. De longe o melhor mecânico da ilha.',
        rating: '5',
      },
      {
        author: 'David Wilson',
        body: "Best mechanic I've found since moving to Madeira. Replaced my brakes and did a full service while I worked from home. Honest assessment, no upselling, excellent quality.",
        rating: '5',
      },
      {
        author: 'Sophie Laurent',
        body: 'Our rental car broke down on the way to the airport and they arrived in under 45 minutes. Sorted the problem quickly and professionally. Absolute lifesavers!',
        rating: '5',
      },
    ],
  },
  faq: {
    items: [
      {
        question: 'Onde operam na Madeira? / Where do you operate in Madeira?',
        answer:
          'Operamos em toda a Ilha da Madeira. Do Funchal a Porto Moniz, cobrimos todas as zonas: Caniço, Santa Cruz, Machico, Câmara de Lobos, Ribeira Brava, São Vicente, Santana, Calheta e Ponta do Sol. We cover the entire island of Madeira.',
      },
      {
        question: 'Atendem o aeroporto da Madeira e turistas com carros de aluguer?',
        answer:
          'Sim. Estamos sediados no Caniço, a poucos minutos do aeroporto da Madeira (FNC). Apoiamos turistas com avarias de carros de aluguer, baterias descarregadas e reparações de emergência em hotéis, no aeroporto e nas estradas da ilha. Yes, we are based minutes from Madeira Airport (FNC) and assist tourists with rental car breakdowns daily.',
      },
      {
        question: 'Em quanto tempo conseguem chegar? / How quickly can you arrive?',
        answer:
          'Na zona central e leste da Madeira (Funchal, Caniço, Santa Cruz, Câmara de Lobos), normalmente chegamos em 30 a 60 minutos. Zonas a oeste e norte (Calheta, Porto Moniz, São Vicente) podem demorar mais consoante a disponibilidade do dia.',
      },
      {
        question: 'Quanto custa uma mudança de óleo ao domicílio na Madeira?',
        answer:
          'O preço depende do veículo e do tipo de óleo, mas o serviço móvel é normalmente igual ou inferior ao de uma oficina tradicional, sem custos de reboque e sem tempo perdido. Damos sempre um orçamento claro antes de iniciar qualquer trabalho.',
      },
      {
        question: 'Que formas de pagamento aceitam? / What payment methods do you accept?',
        answer: 'Aceitamos dinheiro, Multibanco, MB Way e transferência bancária.',
      },
      {
        question: 'Trabalham aos fins de semana? / Do you work on weekends?',
        answer:
          'Procuramos oferecer marcações ao sábado e responder a avarias urgentes quando possível. Ligue ou envie WhatsApp para +351 912 837 918 para confirmar disponibilidade.',
      },
      {
        question: 'Posso pedir uma inspeção pré-compra antes de comprar um carro usado?',
        answer:
          'Sim. Encontramo-nos onde o carro estiver: stand, vendedor particular ou em sua casa, e damos uma avaliação mecânica completa para saber exatamente o estado da viatura antes da compra.',
      },
      {
        question: 'Falam inglês? / Do you speak English?',
        answer:
          'Sim, falamos inglês. Trabalhamos diariamente com turistas, expatriados e residentes de língua inglesa em toda a Madeira. Yes, we work with English-speaking tourists, expats, and residents across Madeira every day.',
      },
    ],
  },
  contact: {
    address: 'Estrada do Aeroporto, Caniço, 9125-086, Madeira, Portugal',
    hours: 'Mon–Fri: 09:00–17:00\nSat: 09:00–13:00',
    email: 'madeiramechanic@gmail.com',
    mapUrl:
      'https://www.google.com/maps?q=Estr.%20do%20Aeroporto%2C%209125-086%20Cani%C3%A7o%2C%20Portugal&output=embed',
    paymentMethods: 'Cash · Multibanco · MB Way · Bank Transfer',
  },
  tourists: {
    heading: "Stranded with a rental car? We're 5 minutes from Madeira Airport.",
    headingPt: 'Avaria com carro de aluguer? Estamos a 5 minutos do aeroporto da Madeira.',
    body: 'Dead battery in a hotel car park. Engine warning light on the way to Cabo Girão. Flat tyre on the ER101. We work with English-speaking tourists in Madeira every day. Emergency mobile mechanic service across the island, no towing required, no Portuguese needed.',
    bodyPt: 'Bateria descarregada no estacionamento do hotel. Luz do motor acesa a caminho do Cabo Girão. Pneu furado na ER101. Trabalhamos diariamente com turistas na Madeira, serviço de mecânico móvel de emergência em toda a ilha, sem necessidade de reboque.',
    feat1Title: 'Madeira Airport (FNC)',
    feat1TitlePt: 'Aeroporto da Madeira (FNC)',
    feat1Body: 'Based in Caniço, the closest mobile mechanic to Madeira Airport. Roadside help for arriving travellers and rental car issues.',
    feat1BodyPt: 'Sediados no Caniço, o mecânico móvel mais próximo do aeroporto da Madeira. Apoio em estrada para passageiros que chegam e problemas com carros de aluguer.',
    feat2Title: 'English Spoken Daily',
    feat2TitlePt: 'Falamos Inglês Diariamente',
    feat2Body: 'No language barrier. We explain the issue clearly and quote in plain English before any work begins.',
    feat2BodyPt: 'Sem barreira linguística. Explicamos o problema com clareza e damos orçamento em linguagem simples antes de qualquer trabalho começar.',
    feat3Title: 'Hotel, Villa, or Roadside',
    feat3TitlePt: 'Hotel, Vivenda ou Estrada',
    feat3Body: 'We come to your accommodation, the rental return, the airport, or the side of the road, anywhere on Madeira.',
    feat3BodyPt: 'Vamos ao seu alojamento, ao stand de aluguer, ao aeroporto ou à beira da estrada, em qualquer ponto da Madeira.',
  },
  sections: {
    heroEyebrow: 'Madeira · Mobile Mechanic · Mecânico ao Domicílio',
    servicesHeading: 'Our Services',
    areasHeading: 'Every Corner of Madeira',
    reviewsHeading: 'What Our Clients Say',
    locationHeading: 'Madeira Island',
    faqHeading: 'Common Questions',
    contactHeading: 'Book Your Service',
  },
  seo: {
    city: 'Caniço',
    region: 'Madeira',
    serviceAreas:
      'Funchal, Caniço, Santa Cruz, Câmara de Lobos, Machico, Ribeira Brava, São Vicente, Santana, Calheta, Ponta do Sol, Porto Moniz, Porto Santo',
    metaDescription:
      'Mecânico ao domicílio em toda a Madeira: Funchal, Caniço, Santa Cruz, Câmara de Lobos. Vamos até si. English-speaking mobile mechanic. 5.0 (100+ reviews). Tel: +351 912 837 918.',
  },
};

export default defaultContent;
